import { ReactElement } from 'react';

type CircleProgressbarProps = {
  percentage: number;
};

/**
 * A Circular Progressbar to show percentage of progress.
 * @param props - CircleProgressbarProps.
 * @returns - Circular Progressbar.
 */
export default function CircleProgressbar(props: CircleProgressbarProps): ReactElement {
  const { percentage } = props;
  const width = 200;
  const strokeWidth = 8;
  const PI = 3.14;
  const R = width / 2 - strokeWidth * 2;
  const circumference = 2 * PI * R;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <div className="flex justify-center items-center">
      <div className="inline-block rounded-full relative h-[200px] w-[200px]">
        <div>
          <span className="absolute h-full w-full top-0 left-0 flex justify-center items-center flex-col text-center text-gray-300 text-5xl font-semibold">
            {percentage}%
          </span>
        </div>

        <svg width="100%" height="100%">
          <circle
            className="stroke-container-50"
            strokeWidth={15}
            fill="transparent"
            r={84}
            cx={width / 2}
            cy={width / 2}
          />
          <circle
            className="-rotate-90 origin-[50%_50%] stroke-primary-500"
            strokeWidth={16}
            fill="transparent"
            r={84}
            cx={width / 2}
            cy={width / 2}
            strokeLinecap="round"
            strokeDasharray={`${circumference} ${circumference}`}
            strokeDashoffset={offset}
          />
        </svg>
      </div>
    </div>
  );
}
